export default __webpack_public_path__ + "8cae91a571eb9bae5e2e638a046d69cf.woff";